import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontWeight: 400,
      fontSize: '0.875rem',
      color: palette.common.black,
      '@media (max-width: 768px)': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }
    },
    divider: {
      fontSize: '1rem',
      '@media (max-width: 768px)': {
        marginTop: '5px',
        marginBottom: '5px',
        fontSize: '1rem',
        transform: 'rotate(90deg)'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
